var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MyADGTransparency/MyADGTransparency.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MyADGTransparency/MyADGTransparency.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MyADGTransparency\">\n\n        <h2>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_5 += "</h2>\n\n        <div class=\"MyADGTransparency-wrapper\">\n            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("block", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") == 9)) {
t_5 += "<div class=\"MyADGTransparency-others\">";
;
}
t_5 += "\n                <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"file"), env.opts.autoescape);
t_5 += "\" class=\"MyADGTransparency-block\" data-icon=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"icon"), env.opts.autoescape);
t_5 += "\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"";
t_5 += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") % 4) * 50, env.opts.autoescape);
t_5 += "\">\n                    <div class=\"MyADGTransparency-blockIcon\"></div>\n                    <div class=\"MyADGTransparency-blockText\">";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "</div>\n                    <div class=\"MyADGTransparency-blockFooter\">Download</div>\n                </a>\n            ";
;
}
}
frame = frame.pop();
t_5 += "\n            ";
if((env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list")) > 8)) {
t_5 += "</div>";
;
}
t_5 += "\n        </div>\n\n        <div ";
if((env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list")) <= 8)) {
t_5 += "style=\"display:none\"";
;
}
t_5 += " class=\"MyADGTransparency-showMoreButton\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\">\n            <button></button>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MyADGTransparency");
context.setVariable("MyADGTransparency", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MyADGTransparency/MyADGTransparency.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGTransparency/MyADGTransparency.jinja
// module id = 521
// module chunks = 0